import { I } from '@angular/cdk/keycodes';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
type PrefixDictionary = { [host: string]: string };

@Injectable({
    providedIn: 'root'
})
export class SiteTitleService {

    //DI Title
    constructor(private siteTitle: Title) { }

    private readonly defaultPrefix: string = 'Assurant Commercial Equipment Protection';

    private readonly prefixMap: PrefixDictionary = {
        // ESPP
        'localhost': 'Assurant Commercial Equipment Protection',
        'model-espp.assurant.com': 'Assurant Commercial Equipment Protection',
        'qa-espp.assurant.com': 'Assurant Commercial Equipment Protection',
        
        // CNH
        'dev-ppp.epgins.com': 'PPP',
        'espp-integration-model.epgins.com': 'PPP',
        'ppp.cnhinsurance.com': 'PPP',
        'qa-espp-protectionp': 'Protection Point',
        'model-espp-cnh.assurant.com': 'PPP',
        'qa-espp-cnh.assurant.com': 'PPP',
        'qa-espp-cnhau.assurant.com': 'PPP AU', // New URL
        'model-espp-cnhau.assurant.com': 'PPP AU', // New URL
        'espp-cnh.assurant.com': 'PPP', // New URL
        'espp-cnhau.assurant.com': 'PPP AU', // New URL
        
         // PPSP
        'dev-ppsp.epgins.com': 'Protection Point',
        'model-espp-protectionpoint.assurant.com': 'Protection Point',
        'qa-espp-protectionpoint.assurant.com': 'Protection Point',
        'protectionpointportal.com': 'Protection Point', // New URL
        'www.protectionpointportal.com': 'Protection Point', // New URL
        'espp-protectionpoint.assurant.com': 'Protection Point', // New URL
        
         // BOMAG
        'dev-bomag.epgins.com': 'Bomag ESPP',
        'model-espp-bomag.assurant.com': 'Bomag ESPP',
        'qa-espp-bomag.assurant.com': 'Bomag ESPP', // Updated key
        'bomagespp.com': 'Bomag ESPP', // New URL
        'www.bomagespp.com': 'Bomag ESPP', // New URL
        'espp-bomag.assurant.com': 'Bomag ESPP', // New URL

        // Dynapac
        'dev-dynapac.epgins.com': 'Dynapac ESPP',
        'model-espp-dynapac.assurant.com': 'Dynapac ESPP',
        'qa-espp-dynapac.assurant.com': 'Dynapac ESPP',
        'dynapacespp.com': 'Dynapac ESPP', // New URL
        'www.dynapacespp.com': 'Dynapac ESPP', // New URL
        'espp-dynapac.assurant.com': 'Dynapac ESPP', // New URL

        // Liebherr
        'dev-liebherr.epgins.com': 'Liebherr ESPP', // New URL
        'model-espp-liebherr.assurant.com': 'Liebherr ESPP', // New URL
        'qa-espp-liebherr.assurant.com': 'Liebherr ESPP', // New URL
        'espp-liebherr.assurant.com': 'Liebherr ESPP', // New URL
    }

    private gettitlePrefix(): string {
        const host = window.location.host;
        if (this.prefixMap[host]) {
            return this.prefixMap[host];
        }
        return this.defaultPrefix;
    }

    public setTitle(pageTitle: string | null): void {
        console.log(this.gettitlePrefix())
        this.siteTitle.setTitle(this.gettitlePrefix() + (pageTitle ? ' | ' + pageTitle : ''));
    }
}
